import { render, staticRenderFns } from "./OrganisationAddAction.vue?vue&type=template&id=cf97257c"
import script from "./OrganisationAddAction.vue?vue&type=script&lang=js"
export * from "./OrganisationAddAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports